import { Location } from '@angular/common';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export const HANDLE_BACK_BUTTON_STATE = 'HANDLE_BACK_BUTTON_STATE';
export const HANDLE_BACK_BUTTON_CLICK_DISMISS =
  'HANDLE_BACK_BUTTON_CLICK_DISMISS';

export class ClosableModal {
  private modalRef?: NgbModalRef;
  // tslint:disable-next-line:no-any
  private originalDismiss?: (reason?: any) => void;

  constructor(ngbModalRef: NgbModalRef, private location: Location) {
    const originalClose = ngbModalRef.close.bind(ngbModalRef);
    const originalDismiss = ngbModalRef.dismiss.bind(ngbModalRef);
    this.originalDismiss = originalDismiss;

    // tslint:disable-next-line:no-any
    ngbModalRef.dismiss = (reason?: any) => {
      this.cleanUpLocationState();
      originalDismiss(reason);
    };

    // tslint:disable-next-line:no-any
    ngbModalRef.close = (result?: any) => {
      this.cleanUpLocationState();
      originalClose(result);
    };

    this.startLocationListening(ngbModalRef);
  }

  public closeModal(): void {
    this.cleanUpLocationState();
    if (this.modalRef && this.originalDismiss) {
      this.originalDismiss(HANDLE_BACK_BUTTON_CLICK_DISMISS);
    }
  }

  private cleanUpLocationState(): void {
    /**
     * it means, that user closed modal not by platform
     * navigation (back\forward), but by himself, thus
     * history.pushState(HANDLE_BACK_BUTTON_STATE, null, window.location.pathname);
     * will be unneeded, and should be reverted
     */
    if (this.location.getState() === HANDLE_BACK_BUTTON_STATE) {
      this.location.back();
    }
  }

  private startLocationListening(modalRef: NgbModalRef): void {
    this.modalRef = modalRef;
    this.location.go(this.location.path(true), '', HANDLE_BACK_BUTTON_STATE);
  }
}
